module.exports = __webpack_public_path__ + "img/HART FIT.1e99d134.png";